import React from 'react';
import { useQuery, gql } from '@apollo/client';
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Typography,
  Box,
  Grid,
  Checkbox,
  TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import Verses from './Verses';
import MultiColumnsSelection from '../components/multiColumnsDropDown/MultiColumnsSelection';
import ChapterVerses from './ChapterVerses';
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    // maxHeight: 350
  }
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function SoSanhCau() {
  const [bible, setBible] = React.useState({
    version: 'V02',
    book: 'V02B43',
    chapter: 'V02B43C001',
    bookSelectedIndex: 42,
    chapterSelectedIndex: 0,
    versionsCompared: [{ id: 'V02', name: 'Bản Dịch 1925', shortName: 'BD1925' }]
  });
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const versionsQuery = gql`
    {
      versions {
        id
        name
        shortName
      }
    }
  `;
  const booksQuery = gql`
    query($id: String!) {
      bible(id: $id) {
        id
        name
      }
    }
  `;

  const chaptersQuery = gql`
    query($id: String!) {
      book(id: $id) {
        chaptersId {
          id
          chapterNumber
        }
      }
    }
  `;

  const chapterQuery = gql`
    query($id: String!) {
      chapter(id: $id) {
        title
        chapterNum
        totalVerse
        id
        textDirection
        wordForChapter
      }
    }
  `;
  // const versionQuery = gql`
  //   query($id: String!) {
  //     version(id: $id) {
  //       id
  //       name
  //       shortName
  //     }
  //   }
  // `;
  const { data: versions } = useQuery(versionsQuery);

  const { data: booksData } = useQuery(booksQuery, {
    variables: { id: bible.version }
  });

  const { data: { book: { chaptersId } = {} } = {} } = useQuery(chaptersQuery, {
    variables: { id: bible.book }
  });

  // const { data: chapterData } = useQuery(chapterQuery, {
  //   variables: { id: bible.chapter }
  // });

  const chaptersIdData =
    chaptersId &&
    chaptersId.map(chapterId => {
      return { ...chapterId, name: chapterId.chapterNumber };
    });

  const versionsChange = (event, values) => {
    setBible({
      ...bible,
      versionsCompared: values
    });
  };
  const bookChange = index => {
    const selectedBook = booksData && booksData.bible[index];
    setBible({
      ...bible,
      book: selectedBook && selectedBook.id,
      chapter: selectedBook && selectedBook.id.concat('C001'),
      bookSelectedIndex: index,
      chapterSelectedIndex: 0
    });
    setPage(0);
  };
  const chapterChange = index => {
    const chapterSelected = chaptersId && chaptersId[index];
    console.log('selected chapter', chapterSelected.id);
    setBible({ ...bible, chapter: chapterSelected.id, chapterSelectedIndex: index });
    setPage(0);
  };
  let chapterLists = [];
  // chapterData &&
  //   chapterData.chapter &&
  bible.versionsCompared.map((version, index) =>
    chapterLists.push(bible.chapter.replace(bible.version, version.id))
  );
  return (
    <div style={{ padding: 20 }}>
      <Grid container>
        {/* <Grid container> */}
        <Grid item xs={12}>
          <Autocomplete
            multiple
            id="checkboxes-versions"
            options={(versions && versions.versions) || []}
            disableCloseOnSelect
            getOptionLabel={option => option && option.name}
            onChange={versionsChange}
            defaultValue={bible.versionsCompared}
            getOptionSelected={(option, value) => {
              return option.id === value.id;
            }}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option && option.name}
              </React.Fragment>
            )}
            // style={{ width: 100% }}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                label="So Sánh Những Bản Dịch"
                placeholder="Các Bản Dịch"
                disabled={true}
              />
            )}
          />
        </Grid>
        {/* </Grid> */}
        {/* <Grid> */}
        <Grid item xs={6}>
          <MultiColumnsSelection
            id="booksList"
            cols={2}
            data={booksData && booksData.bible}
            onSelect={bookChange}
            defaultValue={bible.bookSelectedIndex}
          />
        </Grid>
        <Grid item xs={6}>
          <MultiColumnsSelection
            id="chaptersList"
            cols={chaptersId && chaptersId.length < 5 ? chaptersId.length : 5}
            data={chaptersIdData}
            onSelect={chapterChange}
            defaultValue={bible.chapterSelectedIndex}
          />
        </Grid>
        {/* </Grid> */}
      </Grid>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {bible.versionsCompared &&
                  bible.versionsCompared.map(version => (
                    <TableCell
                      key={version.id}
                      // align={column.align}
                      // style={{ minWidth: column.minWidth }}
                    >
                      <Typography variant="h5" key={version.id}>
                        {version.name}
                      </Typography>
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <TableBody>{<Verses verseList={chapterLists} key={chapterLists[0]} />}</TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          rowsPerPageOptions={[10, 20, 30, 50, 100]}
          component="div"
          count={(versesCompare && versesCompare.length) || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        /> */}
      </Paper>
    </div>
  );
}
export default SoSanhCau;
